import type { ServiceConfigurationDto, ServiceConfigurationInputDto, ServiceConfigurationPagedRequestDto } from './models';
import { RestService, Rest } from '@abp/ng.core';
import { Injectable } from '@angular/core';
import type { PagedResultDto } from '../pagination/models';

@Injectable({
  providedIn: 'root',
})
export class ServiceConfigurationService {
  apiName = 'Default';
  

  createByInputDto = (inputDto: ServiceConfigurationInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'POST',
      url: '/api/app/service-configuration',
      body: inputDto,
    },
    { apiName: this.apiName,...config });
  

  deleteByServiceConfigurationId = (serviceConfigurationId: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: '/api/app/service-configuration',
      params: { serviceConfigurationId },
    },
    { apiName: this.apiName,...config });
  

  editByInputDto = (inputDto: ServiceConfigurationInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'POST',
      url: '/api/app/service-configuration/edit',
      body: inputDto,
    },
    { apiName: this.apiName,...config });
  

  getAllByInput = (input: ServiceConfigurationPagedRequestDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PagedResultDto<ServiceConfigurationDto>>({
      method: 'GET',
      url: '/api/app/service-configuration',
      params: { providerId: input.providerId, vendorId: input.vendorId, serviceId: input.serviceId, purchaseOrderNumber: input.purchaseOrderNumber, state: input.state, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getByIdByServiceConfigurationId = (serviceConfigurationId: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, ServiceConfigurationDto>({
      method: 'GET',
      url: `/api/app/service-configuration/by-id/${serviceConfigurationId}`,
    },
    { apiName: this.apiName,...config });

  constructor(private restService: RestService) {}
}
